export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_STATE_COMPLETE = 'LOGIN_STATE_COMPLETE';
export const LOGIN_STATE_FAILED_COMPLETE = 'LOGIN_STATE_FAILED_COMPLETE';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';